import React from 'react'
import {
    BeatLoader, PulseLoader
} from "react-spinners";
const LoadBox = () => {
    return (
        <div className="d-flex justify-content-center flex-column gap-5 align-items-center px-5 mb-5 h-100">
            <h1 className='mb-0 title-font-bold text-base-color text-capitalize' style={{ fontSize: "30px", letterSpacing: "2px" }}>Loading<span><PulseLoader
                color="#6271de"
                size={5}
            /></span> </h1>
        </div>
    )
}

export default LoadBox
